import React, { PureComponent } from 'react';
import MenuAcordeon from "./MenuAcordeon";

class MenuBase extends PureComponent {
    constructor(props) {
        super(props);

        const { cuentaSeleccionada } = props;
        let currentSubItemId = 0, currentCuentaId;

        if (cuentaSeleccionada) {
            currentSubItemId = 1;
            currentCuentaId = cuentaSeleccionada.Id;
        }

        this.state = {
            currentCuentaId,
            currentSubItemId,
            fetchingData: false
        }
    }

    menuCabeceraOnClick = (event, cuentaId) => {
        if (this.state.currentCuentaId == cuentaId)
            cuentaId = undefined;

        this.setState({ currentCuentaId: cuentaId });
    }

    subMenuDesplegable = (event, itemId, entidadId) => {
        let callback = () => { };
        let currentCuentaId = undefined;

        /*Solamente aplica a al empresa, si se quiere hacer varios clicks se bloquea*/
        if (itemId == 0) {
            if (itemId == this.state.currentSubItemId) {
                return;
            }
        } else {
            /*caso para la cuenta, no solamente el subitem sino que tambien puede cambiar la cuenta*/
            if (itemId == this.state.currentSubItemId
                && entidadId == this.state.currentCuentaId) {
                return;
            }

            currentCuentaId = entidadId;
        }

        switch (itemId) {
            case 0: {
                callback = this.props.getEmpresaData; break;
            }
            case 1: {
                callback = this.props.getCuentaData; break;
            }
            case 2: {
                callback = this.props.getSaldosResumenesData; break;
            }
            case 3: {
                callback = this.props.getTarjetaData; break;
            }
            case 4: {
                callback = this.props.getIngresoAjustesData; break;
            }
            case 5: {
                callback = this.props.getIngresoCobranzasData; break;
            }
        }

        this.setState({
            currentSubItemId: itemId,
            currentCuentaId,
            fetchingData: true
        }, callback(entidadId));
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ fetchingData: false });
    }

    render() {
        const { cuentas, cuentaSeleccionada, empresa } = this.props;
        const { currentCuentaId, currentSubItemId, fetchingData } = this.state;
        const { menuCabeceraOnClick, subMenuDesplegable } = this;
        const saldosResumenes = `Saldos y Res\u00FAmenes`;
        const ingresoAjustes = `Ingreso de Ajustes`;
        
        return (
            <div>
                {fetchingData &&
                    <div className="loading">Loading &#8230;</div>}

                <div className="menu-desplegable">
                    <div className="div-con-wrap">
                        <h4 className={("link no-margin" + ((currentSubItemId == 0) ? " activo" : ""))}
                            onClick={e => subMenuDesplegable(e, 0, empresa.Id)}>{`${empresa.Denominacion} (${empresa.tipoCuentaDescripcion})`}</h4>
                    </div>
                    
                    {cuentas.map((c, index) => {
                        const esCuenta = (c.Id == currentCuentaId);
                        const dtsGralActivo = (1 == currentSubItemId && (c.Id == currentCuentaId));
                        const sldResActivo = (2 == currentSubItemId && (c.Id == currentCuentaId));
                        const tarActivo = (3 == currentSubItemId && (c.Id == currentCuentaId));
                        const inajResActivo = (4 == currentSubItemId && (c.Id == currentCuentaId));
                        const ingcobResActivo = (5 == currentSubItemId && (c.Id == currentCuentaId));

                        return (
                            <MenuAcordeon cuenta={c} key={index} currentCuentaId={currentCuentaId} cabeceraClickEvent={menuCabeceraOnClick}>
                                <div className={"div-con-wrap" + (dtsGralActivo ? " activo" : "")}>
                                    <a className={"link" + (dtsGralActivo ? " activo" : "")} onClick={e => subMenuDesplegable(e, 1, c.Id)}>Datos generales</a>
                                </div>
                                <div className={"div-con-wrap" + (sldResActivo ? " activo" : "")}>
                                    <a className={"link" + (sldResActivo ? " activo" : "")} onClick={e => subMenuDesplegable(e, 2, c.Id)}>{saldosResumenes}</a>
                                </div>
                                <div className={"div-con-wrap" + (inajResActivo ? " activo" : "")}>
                                    <a className={"link" + (inajResActivo ? " activo" : "")} onClick={e => subMenuDesplegable(e, 4, c.Id)}>Ingreso de Ajustes</a>
                                </div>
                                <div className={"div-con-wrap" + (ingcobResActivo ? " activo" : "")}>
                                    <a className={"link" + (ingcobResActivo ? " activo" : "")} onClick={e => subMenuDesplegable(e, 5, c.Id)}>Ingreso de Cobranzas</a>
                                </div>
                                <div className={"div-con-wrap" + (tarActivo ? " activo" : "")}>
                                    <a className={"link" + (tarActivo ? " activo" : "")} onClick={e => {
                                        if ((c.CuentaTarjetaEstadoId != 1)) {
                                            subMenuDesplegable(e, 3, c.Id);
                                        } else {
                                            this.setState({ currentSubItemId: 3, fetchingData: true });
                                        }
                                    }}>Tarjetas</a>
                                </div>
                            </MenuAcordeon>
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default MenuBase;